module.exports = __webpack_public_path__ + "media/images/comment-icon-c6d3f5516386cbf1391177b93626ec08.svg";